import { SLOTS_APIS } from "@/api_framework/api_config";
import { ILateBookingStatusCheckResponse } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
type LateBookingCheckParams = {
  staff_id: string;
  start_time: string; // 24 Hrs
  clinic_id: string;
  service_id: string;
  sub_service_id: string;
};

export const useLateBookingCheckAPI = () => {
  const [status, setStatus] = useState<"DEFAULT" | "AVAILABLE" | "NOT_AVAILABLE">("DEFAULT");
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const clearStatus = () => {
    setStatus("DEFAULT");
  };
  const execute = useCallback(
    async (statusCheckParams: LateBookingCheckParams) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        dispatch(
          setLoading({
            key: "isLateBookingStatusCheckInProgress",
            status: true,
          }),
        );
        setStatus("DEFAULT");
        const response: boolean = await axios
          .get(`${SLOTS_APIS?.LATE_BOOKING_CHECK?.baseURL}` ?? "", {
            params: {
              ...statusCheckParams,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ILateBookingStatusCheckResponse>) => {
            dispatch(
              setLoading({
                key: "isLateBookingStatusCheckInProgress",
                status: false,
              }),
            );
            if (res.data.status === true && res.data) {
              setStatus("AVAILABLE");
              return res.data.data.status;
            } else {
              setStatus("NOT_AVAILABLE");
              return false;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setStatus("NOT_AVAILABLE");
            dispatch(
              setLoading({
                key: "isLateBookingStatusCheckInProgress",
                status: false,
              }),
            );
            if (e.code === "ERR_BAD_REQUEST") {
              // Do something
            }
            if (e.status === 400) {
              // Do Someting
            }
            return false;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return false;
      }
    },
    [dispatch],
  );
  return { status, execute, clearStatus };
};
